import { ICabCapacityWarningProps, CapacityMessageType } from "./store"

export function getCabCapacityWarningInfo({
	cabs,
	children,
	noOfAdults,
	messageType,
}: ICabCapacityWarningProps): {
	hasWarning: boolean
	message: string
} {
	let hasZeroCapacity = false
	let maxComplimentaryAge = 0

	const totalCapacity = (cabs || []).reduce((sum, cab) => {
		const cabCapacity = cab.cab_type?.capacity || 0
		const complementaryAgeTill = cab.cab_type?.capacity_child_age_limit || 0

		if (complementaryAgeTill > maxComplimentaryAge) {
			maxComplimentaryAge = complementaryAgeTill
		}
		if (cabCapacity < 1 && !hasZeroCapacity) {
			hasZeroCapacity = true
		}

		return sum + (cab?.no_of_cabs || 1) * cabCapacity
	}, 0)
	//If any car has no capacity, then the warning message should not be shown.
	if (hasZeroCapacity) {
		return {
			hasWarning: false,
			message: messageType,
		}
	}
	// Children data comes in descending order from the API.
	const sortedChildrenAges: number[] = (children || []).map((c) => c.age)

	const startIndexOfComplimentaryChildren = getPositionByBinarySearchDescending(
		sortedChildrenAges,
		maxComplimentaryAge
	)

	const paidChildren = sortedChildrenAges.slice(
		0,
		startIndexOfComplimentaryChildren
	)

	if (noOfAdults + paidChildren.length > totalCapacity) {
		return {
			hasWarning: true,
			message: getCabCapacityMessage(
				messageType,
				totalCapacity,
				noOfAdults + paidChildren.length
			),
		}
	}

	return {
		hasWarning: false,
		message: "",
	}
}

function getPositionByBinarySearchDescending(
	arr: number[],
	value: number
): number {
	let left = 0
	let right = arr.length

	while (left < right) {
		const mid = Math.floor((left + right) / 2)

		if (arr[mid] > value) {
			left = mid + 1
		} else {
			right = mid
		}
	}

	return left
}

function getCabCapacityMessage(
	type: CapacityMessageType,
	expectedPax: number,
	actualPax: number
): string {
	switch (type) {
		case "withPax":
			return `Cab capacity exceeded. Expected: ${expectedPax} Pax, Actual: ${actualPax} Pax`

		case "withoutPax":
			return "Cab capacity exceeded. Please select a cab with sufficient capacity"

		default:
			return "Cab capacity exceeded. Please select a cab with sufficient capacity"
	}
}
